/**
 * Generic Iterable Signup Handler
 *
 * Add data attributes to any form to enable Iterable integration:
 *
 * <form
 *   id="ContactFooter"
 *   data-iterable-email-input-id="NewsletterForm"
 *   data-iterable-source="footer">
 *   <input type="email" id="NewsletterForm" />
 *   <button type="submit">Sign up</button>
 * </form>
 */

(function() {
  'use strict';

  // Check if config exists
  if (!window.iterableConfig) {
    return;
  }

  const config = window.iterableConfig;

  // Find all forms with data-iterable-email-input-id and data-iterable-source
  const forms = document.querySelectorAll('form[data-iterable-email-input-id][data-iterable-source]');

  if (!forms.length) {
    return;
  }

  // Helper function to capitalize first letter
  function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  // Setup each form
  forms.forEach(function(form) {
    const emailInputId = form.getAttribute('data-iterable-email-input-id');
    const sourceParam = form.getAttribute('data-iterable-source');

    if (!emailInputId || !sourceParam) {
      return;
    }

    const emailInput =
      form.querySelector(`#${emailInputId}`) ||
      document.getElementById(emailInputId);

    if (!emailInput) {
      return;
    }

    // Form submit handler
    form.addEventListener('submit', async function(e) {
      const email = emailInput.value.trim();

      if (!email || !config.apiUrl || !config.apiKey) {
        // Let form submit naturally
        return;
      }

      // Build siteID and source
      const siteID = `${config.brand}_${config.region}`.toUpperCase();
      const source = `${capitalizeFirstLetter(config.brand)}_${sourceParam}`;

      // Build payload
      const payload = {
        requestType: 'sendDataToIterable',
        siteID: siteID,
        data: {
          email: email,
          country: config.countryName,
          countryCode: config.countryCode,
          source: source
        }
      };

      // Fire-and-forget API call
      try {
        fetch(`${config.apiUrl}/admin-actions`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': config.apiKey
          },
          body: JSON.stringify(payload)
        }).catch(err => {
          // Silent fail - don't block form submission
        });
      } catch (err) {
        // Silent fail - don't block form submission
      }

      // Form submission continues naturally (no preventDefault)
    });
  });
})();
